export class CreateUserRequest {

    public name : string="";
    public password : string="";
    public id_Rol : number=0;
    public id_Persona : number=0;
    public idEmpresa : number=0;

}
